import React from 'react';
import logo from "../assets/logo.jpg"
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";

const Colabora = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <div className='bg-gray-50 min-h-screen pt-28 pb-20 px-4'>
        <div className='max-w-5xl mx-auto'>
          
          {/* Título de la página */}
          <div className='text-center mb-16'>
            <h1 className='text-4xl md:text-6xl font-black text-slate-900 mb-4 uppercase tracking-tighter'>
              Colabora con <span className='text-blue-700'>Nosotros</span>
            </h1>
            <div className='w-24 h-2 bg-blue-600 mx-auto rounded-full'></div>
          </div>

          {/* Tarjeta de Donación */}
          <div className='bg-white shadow-2xl rounded-[2.5rem] overflow-hidden border border-gray-100 grid md:grid-cols-2'>
            
            {/* Parte Izquierda: Visual y Legal */}
            <div className='bg-slate-50 p-8 md:p-12 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-gray-200'>
              <img 
                className='w-56 md:w-64 rounded-2xl shadow-xl mb-10 transform transition hover:scale-105 duration-500' 
                src={logo} 
                alt='Logo Fundación' 
              />
              
              <div className='bg-blue-50 p-6 rounded-2xl border border-blue-100'>
                <p className='text-blue-800 text-sm leading-relaxed text-center font-medium'>
                  "La Fundación Vida y Obra del Docente Javier Duque Duque se acoge al principio de buena fe establecido en el Artículo 768 del Código Civil Colombiano acerca del origen lícito de los recursos provenientes de terceros."
                </p>
              </div>
            </div>

            {/* Parte Derecha: Datos Bancarios y Contacto */}
            <div className='p-8 md:p-12 flex flex-col justify-center space-y-8'>
              
              <div>
                <h2 className='text-3xl font-bold text-slate-800 mb-4'>Realiza tu donación</h2>
                <div className='bg-slate-800 p-6 rounded-2xl text-white shadow-lg'>
                  <p className='text-lg md:text-xl font-light leading-relaxed'>
                    A través de transferencia bancaria a la cuenta de ahorros número <span className='font-bold text-blue-400'>431-00043-6</span> del <span className='font-bold'>Banco Cooperativo</span> a nombre de <span className='italic'>fundadocentejdd</span> nit <span className='font-bold'>900984232-9</span>.
                  </p>
                </div>
              </div>

              <div className='space-y-4'>
                <h3 className='text-blue-600 font-bold text-xl flex items-center gap-2'>
                  <span>✓</span> No olvides solicitar tu certificado
                </h3>
                <p className='text-slate-600 leading-relaxed'>
                  Envia copia de tu transferencia o consignacion al correo <span className='font-semibold text-slate-800'>fundadoncentejdd@gmail.com</span> y whatsapp <span className='font-semibold text-slate-800'>3007531988</span>, no olvides solicitar tu certificado de donación.
                </p>
              </div>

              {/* Botones de acción rápida */}
              <div className='flex flex-col sm:flex-row gap-4 pt-4'>
                <div className='flex-1 bg-gray-100 p-3 rounded-xl text-center text-sm font-bold text-slate-700'>
                   📧 Correo: fundadoncentejdd@gmail.com
                </div>
                <div className='flex-1 bg-green-50 p-3 rounded-xl text-center text-sm font-bold text-green-700 border border-green-100'>
                   📱 WhatsApp: 3007531988
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default Colabora;